import { useMemo } from 'react';

import useScopeFilters from '@/data/hook/shared/useScopeFilters';
import useAuth from '@/data/hook/useAuth';
import { ListKlassesFilters } from '@/data/services/klassServices';
import { isUnitStaff } from '@/functions/auth';
import { KlassStatusEnum } from '@/models/Klass';

const UNIT_STAFF_KLASS_STATUS = [
  KlassStatusEnum.OPEN,
  KlassStatusEnum.IN_PROGRESS,
];

export default function useStaffKlassFilters(): ListKlassesFilters {
  const { user } = useAuth();
  const scopeFilters = useScopeFilters();
  const isUserUnitStaff = isUnitStaff(user?.userType);

  return useMemo(
    () => ({
      ...scopeFilters,
      status: isUserUnitStaff ? UNIT_STAFF_KLASS_STATUS : undefined,
    }),
    [scopeFilters, isUserUnitStaff],
  );
}
